// App name: POST PURPOSE
// Description:
//


const PostApp = (function ($) {

  // variables
  let _postCollapseBtn = $('.js-post-collapse');
  let _openFormComment = $('.js-open-comment-form');
  let _openListComment = $('.js-open-comment-list');
  let _postReaction    = $('.post_custom__reaction');

  // init
  function init() {
    //
    collapseHandle();
    toggleCommentForm();
    toggleCommentList();
    // dislikeStatus();
    // dislikeNumberStatus()
  }

  //function name
  function collapseHandle() {
    if(_postCollapseBtn.length) {
      _postCollapseBtn.on('click', function() {
        $(this).closest('.post_custom').toggleClass('collapsed expand')
        .closest('.flw .item').toggleClass('active');
      })
    }
  }

  function toggleCommentForm() {
    if(_openFormComment.length) {
      _openFormComment.on('click', function(){
        $(this)
        .closest('.post_custom').toggleClass('expand-comment-form')
        .find('.post_custom__commentform').toggle();
      })
    }
  }

  function toggleCommentList() {
    if(_openListComment.length) {
      _openListComment.on('click', function(){
        $(this)
        .closest('.post_custom')
        .find('.post_custom__comments').toggleClass('expand');
      })
    }
  }

  function dislikeStatus() {
    if (_postReaction.length > 0) {
      let _dislikeBtn = $('.pld-dislike-wrap a.pld-dislike-trigger');
      _dislikeBtn.on('click', function() {
        let self =$(this);
        if (!self.hasClass('pld-prevent')) {
          $(this).addClass('pld-prevent');
          let parentSelf = self.parent('.pld-dislike-wrap');
          let dislikeNumber = parentSelf.find('span.pld-dislike-count-wrap');
          dislikeNumber.addClass('active');
        }
      })
    }
  }

  function dislikeNumberStatus() {
    let dislike = $('.pld-dislike-trigger.pld-like-dislike-trigger.pld-prevent');
    if (dislike.length > 0) {
      console.log('run')
      let wrap = dislike.parent('.pld-dislike-wrap');
      wrap.find('.pld-dislike-count-wrap').addClass('active');
    }
  }

  return {
    init: init,
  };
})(jQuery);

jQuery('document').ready(function () {
  PostApp.init();
});
